import { Card } from "@/components/ui/card";

export function SectionCard({ title, description, actions, children, className = "", bodyClassName = "", testid, eyebrow }) {
  return (
    <Card className={`bg-card border-border rounded-xl elev-1 ${className}`} data-testid={testid}>
      {(title || actions) && (
        <div className="flex flex-wrap items-start justify-between gap-3 px-5 pt-5">
          <div className="min-w-0">
            {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
            {title && <h3 className="text-[15px] font-semibold text-foreground">{title}</h3>}
            {description && <p className="text-xs text-muted-foreground mt-1 leading-relaxed max-w-2xl">{description}</p>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={`p-5 ${bodyClassName}`}>{children}</div>
    </Card>
  );
}

export function KpiCard({ label, value, sub, accent = false, testid, icon: Icon, tone }) {
  const toneCls =
    tone === "good" ? "text-[hsl(160_55%_52%)]" : tone === "bad" ? "text-[hsl(0_72%_62%)]" : accent ? "text-primary" : "text-foreground";
  return (
    <div
      className={`rounded-xl border p-4 bg-card elev-1 ${accent ? "border-[color:var(--hairline)] bg-[hsl(43_30%_8%)]" : "border-border"}`}
      data-testid={testid}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground font-medium">{label}</span>
        {Icon && <Icon className="h-4 w-4 text-primary/80" />}
      </div>
      <div className={`num text-xl md:text-2xl tracking-tight mt-2 leading-tight ${toneCls}`}>{value}</div>
      {sub && <div className="text-[11px] text-muted-foreground mt-1.5 leading-snug">{sub}</div>}
    </div>
  );
}

export function Segmented({ value, onChange, options, testid, disabled, size = "md" }) {
  return (
    <div
      className={`inline-flex flex-wrap rounded-lg border border-border bg-[hsl(220_12%_8%)] p-1 gap-1 ${disabled ? "opacity-70 pointer-events-none" : ""}`}
      data-testid={testid}
      role="radiogroup"
    >
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(o.value)}
            data-testid={`${testid}-${o.value}`}
            className={`press rounded-md ${size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-xs sm:text-sm"} font-medium ${
              active
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground hover:bg-[hsl(220_10%_13%)]"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export function InfoNote({ children, className = "", testid }) {
  return (
    <div
      className={`rounded-lg border border-[color:var(--hairline)] bg-[hsl(43_30%_7%)] px-3.5 py-2.5 text-xs text-[hsl(45_20%_82%)] leading-relaxed ${className}`}
      data-testid={testid}
    >
      {children}
    </div>
  );
}

export function Row({ label, value, strong, muted, testid, negative }) {
  return (
    <div className={`flex items-center justify-between gap-4 py-2 border-b border-border/70 last:border-0 ${strong ? "pt-3" : ""}`} data-testid={testid}>
      <span className={`text-sm ${muted ? "text-muted-foreground" : strong ? "text-foreground font-semibold" : "text-[hsl(45_15%_82%)]"}`}>{label}</span>
      <span className={`num text-sm text-right ${strong ? "text-primary font-semibold text-base" : negative ? "text-[hsl(0_72%_64%)]" : "text-foreground"}`}>
        {value}
      </span>
    </div>
  );
}
